import React, { useContext, useEffect, useState } from 'react';
import TailwindLayout from 'TailwindcssComponents/TailwindLayout';
import TopBar from 'TailwindcssComponents/TopBar';
import DataTable from 'TailwindcssComponents/Tables';
import axios from 'axios';
import FooterTailwind from 'TailwindcssComponents/Footer';
import { ToastContainer, toast } from 'react-toastify';
import { UserDataContext } from 'context';
import VenueFeatureModel from './Models/venueFeatureModel';

export default function VenueFeature() {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const bearerToken = localStorage.getItem('token');
    const { userData, selectedOrganization } = useContext(UserDataContext);
    const userRole = userData?.isAdmin ? 'admin' : selectedOrganization?.name || 'user';
    const [isLoading, setIsLoading] = useState(true);
    const [featureData, setFeatureData] = useState([]);
    const [selectedFeatureId, setSelectedFeatureId] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [totalItemsCount, setTotalItemsCount] = useState(0);
    const [totalPagesCount, setTotalPagesCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [filteredFeatures, setFilteredFeatures] = useState([]);
    const [openModel, setOpenModel] = useState();

    const fetchVenueFeature = async () => {
        try {
            setIsLoading(true);
            const response = await axios.get(`${apiUrl}event-service/venue-feature`, { params: { page: currentPage, limit: rowsPerPage, name: searchTerm } });
            if (response.data?.success) {
                setFeatureData(response.data.data);
                setFilteredFeatures(response.data.data);
                setTotalItemsCount(response.data.totalItems || 0);
                setTotalPagesCount(response.data.totalPages || 0);
                setTotalPagesCount(response.data.totalPages || 0);
            } else throw new Error(response.data?.message || 'Error in fetching venue feature');
        } catch (error) {
            console.error(error.response?.data?.message || error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleActionClick = (id, action) => {
        if (action === 'edit') {
            handleOpenModel(id);
        }
        else if (action === 'delete') {
            handleDelete(id);
        }
    };

    const handleDelete = async (id) => {
        setSelectedFeatureId(id);
        setOpenDeleteDialogBox(true);
    };

    const filterCategory = (term) => {
        if (!term) {
            setFilteredFeatures(featureData); // Reset to all data if search term is empty
            return;
        }
        const lowerCaseTerm = term.toLowerCase();
        const filtered = featureData.filter((feature) =>
            feature.name.toLowerCase().includes(lowerCaseTerm) // Filter by name
        );
        setFilteredFeatures(filtered);
    };

    const handleSearch = (term) => {
        setSearchTerm(term);
        filterCategory(term);
    };

    useEffect(() => {
        fetchVenueFeature();
    }, [bearerToken, currentPage, rowsPerPage, searchTerm, openModel]);

    const formattedDate = (date) => {
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return new Date(date).toLocaleDateString('en-GB', options);
    };

    const columns = [
        {
            key: 'name', label: 'Features',
            render: (row) => (
                <div className="flex items-center gap-3">
                    <span>{row.name}</span>
                </div>
            ),
        },
        { key: 'createdAt', label: 'Created Date', render: (row) => formattedDate(row.createdAt) },
    ];

    const handleOpenModel = (id) => {
        setSelectedFeatureId(typeof id === 'string' || typeof id === 'number' ? id : null);
        setOpenModel(true);
    }

    const handleCloseModel = () => {
        setOpenModel(false);
    };

    return (
        <TailwindLayout>
            <TopBar />
            <div className="p-12 bg-gray-100 min-h-screen">
                <DataTable
                    title={'Venue Features'}
                    rows={filteredFeatures} columns={columns}
                    onActionClick={handleActionClick}
                    options={{ showHeader: false, showHeaderTwo: true, viewOption: false, editOption: true, addOption: true, statusFilterOption: false, dateFilterOption: false, typeFilterOption: false, searchOption: true }}
                    handleDialogBoxes={handleOpenModel}
                    totalCount={totalItemsCount}
                    pagesCount={totalPagesCount}
                    currentPage={currentPage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={(limit) => setRowsPerPage(limit)}
                    onPageChange={(page) => setCurrentPage(page)}
                    // eventStatus={eventStatus}
                    // onStatusChange={(status) => setEventStatus(status)}
                    // categories={eventCategories}
                    // onCategoryChange={(id) => setSelectedFeatureId(id)}
                    // category={selectedCategoryName}
                    // onDateChange={(date) => setSelectedDate(date)}
                    // filteredDate={selectedDate}
                    onSearch={handleSearch}
                    searcItem={searchTerm}
                    role={userRole}
                    loaderStatus={isLoading}
                    addButtonTitle={'Add New Feature'}
                />
            </div>
            <VenueFeatureModel
                open={openModel}
                onClose={handleCloseModel}
                featureId={selectedFeatureId}
            />
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <FooterTailwind />
        </TailwindLayout>
    )
}